var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "#fff",
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.1c0-.331.266-.6.593-.6h15.814c.328 0 .593.269.593.6s-.265.6-.593.6H2.593A.597.597 0 012 4.1zM2 10c0-.331.263-.6.588-.6h8.824c.325 0 .588.269.588.6s-.263.6-.588.6H2.588A.594.594 0 012 10zm0 6.25c0-.331.261-.6.583-.6h5.833c.322 0 .583.269.583.6s-.261.6-.583.6H2.583a.592.592 0 01-.583-.6z"
  })));
}

export default SvgMenu;